// Montessori
import React from 'react';
import NationalScienceDay2025  from 'views/NationalScienceDay2025';

const Montessoripage = () => {
  return <NationalScienceDay2025/>;
};

export default Montessoripage;